/**
 * Shortcut catalog route - 7 LOW Day-1 SKUs (LEGAL Sec.5 lock)
 *
 * BUG-2026-05-05-03 lateral fix: card uses flex column + CTA-style
 * footer pinned bottom via marginTop:auto so meta line shares baseline
 * across cards regardless of description length.
 *
 * BUG-2026-05-05-02: VN/EN render via useLang().
 */

import { listCatalog, type CatalogEntry } from '@core/shortcut-helpers';
import { useLang } from '../use-lang';

export function ShortcutCatalogRoute() {
  const { lang } = useLang();
  const items: CatalogEntry[] = listCatalog(lang);

  const t = {
    heading: lang === 'vi' ? 'Shortcut' : 'Shortcut',
    intro: lang === 'vi'
      ? 'Wizard 5-10 bước cho 7 use case phổ biến (gia hạn TRC, đổi WP, mẫu HĐLĐ...).'
      : 'Wizard 5-10 steps for 7 common use cases (TRC renewal, WP change, labor contract template...).',
    steps: lang === 'vi' ? 'bước' : 'steps',
    minutes: lang === 'vi' ? 'phút' : 'min',
  };

  return (
    <main>
      <h1>{t.heading}</h1>
      <p style={{ color: 'var(--color-muted)' }}>{t.intro}</p>
      <div className="catalog-grid">
        {items.map((sc) => {
          const title = lang === 'vi' ? sc.title_vn : sc.title_en;
          const desc = lang === 'vi' ? sc.description_vn : sc.description_en;
          return (
            <a
              key={sc.shortcut_id}
              href={`/shortcut/${sc.shortcut_id}`}
              style={{
                display: 'flex',
                flexDirection: 'column',
                padding: 20,
                border: '1px solid var(--color-border)',
                borderRadius: 8,
                background: 'var(--color-card)',
                textDecoration: 'none',
                color: 'inherit',
                height: '100%',
              }}
            >
              <header
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'baseline',
                }}
              >
                <h3 style={{ margin: 0 }}>{title}</h3>
                <small style={{ color: 'var(--color-muted)' }}>{sc.segment.toUpperCase()}</small>
              </header>
              <p style={{ color: 'var(--color-muted)', margin: '8px 0 12px' }}>{desc}</p>
              <small style={{ marginTop: 'auto' }}>
                {sc.step_count} {t.steps} - ~{sc.est_minutes} {t.minutes}
              </small>
            </a>
          );
        })}
      </div>
    </main>
  );
}
